<script lang="ts">
import { isMenuOpen } from '../../../utils/store.js';
import Nav from '../../molecules/Nav/Nav.svelte';

interface Props {
    isOpen?: boolean;
}

let { isOpen = $bindable(false) }: Props = $props();

isMenuOpen.subscribe((value) => {
    isOpen = value;
});
</script>

<section class="menu" class:menu--open={isOpen}>
    <Nav />
</section>

<style lang="scss">
    @use '/src/scss/global-constants/mq-config';
    @use 'sass-mq/mq' as *;

    .menu {
        background: var(--colour-pickled-pineapple);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        left: 0;
        width: 100%;
        opacity: 0;
        padding: 10rem var(--layout-pagegrid-margin) 5rem;
        position: fixed;
        top: 0;
        transform: translateX(-100%);
        transition:
            opacity var(--timing-duration-long),
            transform var(--timing-duration-long);
        z-index: -1;
        border-right: 1px solid var(--colour-jupiter);
        min-height: 100vh;

        &--open {
            transform: translateX(0);
            opacity: 1;
        }

        @include mq($from: tablet) {
            background: none;
            opacity: 1;
            transform: translateX(0);
            border-right: 0;
            flex-direction: row;
            position: static;
            padding: 0;
            height: auto;
            align-self: center;
            flex: 0 1 50%;
            min-height: auto;
        }
    }
</style>
